import Http from "@/libs/axios";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
    itemSelectOptions: [],
    itemFullAreaOptions: [],
  },
  getters: {
    items: (state) => {
      return state.items;
    },
    itemSelectOptions: (state) => {
      return state.itemSelectOptions || [];
    },
    itemFullAreaOptions: (state) => {
      return state.itemFullAreaOptions;
    },
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      state.items = items;
    },
    SET_ITEM(state, item) {
      state.item = item;
    },
    SET_SELECT_OPTIONS(state, items) {
      let listOfObjects = Object.keys(items).map((key) => {
        return items[key];
      });

      // listOfObjects.map((index, item) => {
      //   return { value: index, text: item };
      // });

      state.itemSelectOptions = [
        { value: null, text: "Please select area" },
        ...listOfObjects,
      ];
    },
    SET_FULLAREA_OPTIONS(state, items) {
      let listOfObjects = Object.keys(items).map((value) => {
        let text = items[value];
        return { value: value, text: text };
      });

      state.itemFullAreaOptions = [
        { value: null, text: "Please select area" },
        ...listOfObjects,
      ];
    },
  },
  actions: {
    getSelectOptions({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Http.get("area/select-options")
          .then((response) => {
            commit("SET_SELECT_OPTIONS", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    getFullAreaOptions({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Http.get("area/select-fullarea-options")
          .then((response) => {
            commit("SET_FULLAREA_OPTIONS", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    getAreaList({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Http.get("area/get-list")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    getList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Http.get("area", { params: params })
          .then((response) => {
            commit("SET_ITEM_LIST", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },

    show({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        Http: get(`area/${id}`)
          .then((response) => {
            commit("SET_ITEM", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    create({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("area", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    update({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.put(`area/${encodeURIComponent(payload.AreaID)}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    destroy({}, { id }) {
      return new Promise((resolve, reject) => {
        Http.delete(`area/${encodeURIComponent(id)}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
